import _ from "lodash";

import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

import fireflies from "./store_modules/fireflies";
import carePackages from "./store_modules/care-packages";
import locations from "./store_modules/locations";
import types from "./store_modules/types";
import patterns from "./store_modules/patterns";
import pathfinders from "./store_modules/pathfinders";
import elements from "./store_modules/elements";
import items from "./store_modules/items";
import badwords from "./store_modules/badwords";

const state = {
  errors: [],
  devicePathfinders: []
};

const getters = {
  getElementBackground: state => pathfinder => {
    if (pathfinder && pathfinder.element) {
      const element = state.elements.elements.find(
        el => el.key === pathfinder.element
      );
      if (element) {
        return `url(${element.background})`;
      } else {
        return null;
      }
    }
  }
};

const mutations = {
  UPDATE_ERRORS(state, errors) {
    state.errors = errors;
  },

  ADD_DEVICE_PATHFINDER(state, pathfinder) {
    if (!state.devicePathfinders.includes(pathfinder.id)) {
      state.devicePathfinders.push(pathfinder.id);
    }
  }
};

const actions = {
  updateErrors({ commit }, errors) {
    commit("UPDATE_ERRORS", errors);
  },

  savePathfinderToDevice({ commit }, pathfinder) {
    commit("ADD_DEVICE_PATHFINDER", pathfinder);
  },

  loadLocationPathfinders({ state, dispatch }, locationKey) {
    const location = state.locations.locations.find(l => l.key === locationKey);
    const params = { locationId: location.id };
    return new Promise(resolve => {
      dispatch("getPathfindersByLocation", { params }).then(response => {
        if (response.status == 200) {
          resolve(response.data);
        } else {
          resolve([]);
        }
      });
    });
  },

  loadDevicePathfinders({ state, dispatch }) {
    if (state.devicePathfinders.length > 0) {
      const params = { ids: state.devicePathfinders };
      return new Promise(resolve => {
        dispatch("getPathfindersByIds", { params }).then(response => {
          if (response.status == 200) {
            resolve(response.data);
          }
        });
      });
    } else {
      return new Promise(resolve => resolve([]));
    }
  }
};

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    pathfinders,
    types,
    patterns,
    items,
    elements,
    locations,
    fireflies,
    carePackages,
    badwords
  },
  plugins: [vuexLocal.plugin]
});

export default store;
